export default "__VITE_ASSET__Dg$UuXaK__"